import { AxiosPromise } from "axios";
import configs from "../configs";
import { DashboardLiveApi } from "./live/DashboardLiveApis";



export class DashboardApi {
    private static dashboardApi: DashboardLiveApi = new DashboardLiveApi();


    static getMedia(page: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getMedia(page);
        }
    }


    static getLegacyMedia(page: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getLegacyMedia(page);
        }
    }



    static deleteRecipient(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.deleteRecipient(data);
        }
    }


    static processPayment(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.processPayment(data);
        }
    }



    static getSharedUsers(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getSharedUsers(id);
        }
    }

    static getUserSubscription(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getUserSubscription();
        }
    }

    static markSubscriptionModalViewed(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.markSubscriptionModalViewed();
        }
    }

    static getSubscriptionModalStatus(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getSubscriptionModalStatus();
        }
    }

    static toggleAutoRenew(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.toggleAutoRenew('');
        }
    }

    static cancelSubscription(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.cancelSubscription('');
        }
    }

    static updatePaymentMethod(planData: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.updatePaymentMethod(planData);
        }
    }

    static updateSubscriptionPlan(cardData: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.updateSubscriptionPlan(cardData);
        }
    }

    static getBillingHistory(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getBillingHistory();
        }
    }

    static downloadInvoice(invoiceId: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.downloadInvoice(invoiceId);
        }
    }


    static getSharedWithMe(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getSharedWithMe();
        }
    }



    static shareMedia(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.shareMedia(data);
        }
    }

    static removeSharedAccess(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.removeSharedAccess(id);
        }
    }

    static getUserData(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getUserData();
        }
    }

    static deleteMedia(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.deleteMedia(id);
        }
    }


    static updateUserData(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.updateUserData(data);
        }
    }


    static createGroup(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createGroup(data);
        }
    }


    static getMySharedGroups(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getMySharedGroups();
        }
    }

    static myGroups(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.myGroups();
        }
    }


    static deleteGroup(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.deleteGroup(id);
        }
    }

    static updateGroup(id: any, data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.updateGroup(id, data);
        }
    }


    static getMediaUsage(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getMediaUsage();
        }
    }

    static getScheduledMedia(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getScheduledMedia();
        }
    }

    static getScheduledMediaByDate(date: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getScheduledMediaByDate(date);
        }
    }

    static scheduleMedia(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.scheduleMedia(data);
        }
    }

    static deleteScheduledMedia(id: number): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.deleteScheduledMedia(id);
        }
    }


    //   static getReceivedMedia(): AxiosPromise<Array<any>> {
    //     if (configs.type === "LOCAL") {
    //       return {} as AxiosPromise;
    //     } else {
    //       return this.dashboardApi.getReceivedMedia();
    //     }
    //   }

    //   static getReceivedMediaDetails(id: number): AxiosPromise<Array<any>> {
    //     if (configs.type === "LOCAL") {
    //       return {} as AxiosPromise;
    //     } else {
    //       return this.dashboardApi.getReceivedMediaDetails(id);
    //     }
    //   }

    //   static getUnreadMediaCount(): AxiosPromise<Array<any>> {
    //     if (configs.type === "LOCAL") {
    //       return {} as AxiosPromise;
    //     } else {
    //       return this.dashboardApi.getUnreadMediaCount();
    //     }
    //   }


    static getReceivedMedia(page: number = 1, type: string = 'all', perPage: number = 10): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getReceivedMedia(page, type, perPage);
        }
    }

    static getLatestScheduledMedia(page: number = 1): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getLatestScheduledMedia(page);
        }
    }

    static getMediaDetails(id: number, type: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getMediaDetails(id, type);
        }
    }

    static markMediaAsViewed(id: number, type: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.markMediaAsViewed(id, type);
        }
    }





    static getRecipient(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getRecipient();
        }
    }


    static checkContacts(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.checkContacts();
        }
    }


    static getRecipientGroup(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getRecipientGroup();
        }
    }

    static getRecipientDetails(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getRecipientDetails(id);
        }
    }

    static createRecipient(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createRecipient(data);
        }
    }

    static editRecipient(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.editRecipient(data);
        }
    }


    static UploadMedia(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.UploadMedia(data);
        }
    }

    static uploadBankDoc(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.uploadBankDoc(data);
        }
    }






    static uploadKyc(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.uploadKyc(data);
        }
    }



    static applyStudentLoan(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.applyStudentLoan(data);
        }
    }

    static makeSchoolPayment(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.makeSchoolPayment(data);
        }
    }

    static makePayment(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.makePayment(data);
        }
    }


    static makePaymentFromWallet(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.makePaymentFromWallet(data);
        }
    }




    static makePaymentWithInterswitch(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.makePaymentWithInterswitch(data);
        }
    }

    static addSchool(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.addSchool(data);
        }
    }

    static getAllSchool(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getAllSchool(pageNo, query);
        }
    }

    static getSchoolList(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getSchoolList();
        }
    }




    static getPaymentHistory(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getPaymentHistory(pageNo, query);
        }
    }

    static getPendingPaymentHistory(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getPendingPaymentHistory();
        }
    }




    static getPaymentDetail(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getPaymentDetail(id);
        }
    }



    static getCallback(reference: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getCallback(reference);
        }
    }

    static verifyLoan(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.verifyLoan();
        }
    }

    static verifyKyc(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.verifyKyc();
        }
    }



    static swap(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.swap();
        }
    }


    static generateQuote(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.generateQuote(data);
        }
    }



    static createDynamicAccount(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createDynamicAccount(data);
        }
    }


    static getDashboardData(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getDashboardData();
        }
    }

    static verifyInterswitchPayment(reference: any, amount: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.verifyInterswitchPayment(reference, amount);
        }
    }


    static createCreditEligibility(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createCreditEligibility(data);
        }
    }

    static getSingleCreditEligibity(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getSingleCreditEligibity(id);
        }
    }

    static createSchoolForm(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.createSchoolForm(data);
        }
    }

    static applyStudyLoan(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.applyStudyLoan(data);
        }
    }

    static admissionProcess(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.admissionProcess(data);
        }
    }


    static getSingleSchoolForm(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.dashboardApi.getSingleSchoolForm(id);
        }
    }





}